import { complement, compose, contains, curry, isNil, not, prop } from "ramda";
import { isURL, isMobilePhone } from "validator";

export const hasCapitalLetter = (a) => /[A-Z]/.test(a);
const isGreaterThan = curry((len, a) => a > len);
export const isLengthGreaterThan = (len) =>
  compose(isGreaterThan(len), prop("length"));
export const notNull = complement(isNil);
export const isNotEmptyOrDollar = (a) => not(contains(a, ["", "$"]));
export const isValidURL = (a) => isURL(a, { require_protocol: true });
export const notEqualTo = (param) => (value) => param !== value;
export const isMobile = (str) => (str ? isMobilePhone(str, "any") : true);

export default {
  hasCapitalLetter,
  isLengthGreaterThan,
  notNull,
};
